"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Button, Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
import { TextMono } from "../ui/text";
import { useGlobalsCssTemplate } from "./templates/globals-css";
import { useColorsTsTemplate } from "./templates/colors-ts";
import { CodePreview } from "./code-preview";
import { ClipboardDocumentCheckIcon, ClipboardDocumentListIcon } from "@heroicons/react/16/solid";
import { useMediaQuery } from "@/hooks/use-media-query";
import { useIsMounted } from "@/hooks/use-is-mounted";
const CopyButton = t0 => {
  const $ = _c(9);
  const {
    onCopy
  } = t0;
  const [isCopied, setIsCopied] = useState(false);
  let t1;
  if ($[0] !== onCopy) {
    t1 = () => {
      onCopy();
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    };
    $[0] = onCopy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isCopied) {
    t2 = isCopied ? <ClipboardDocumentCheckIcon className="size-4" /> : <ClipboardDocumentListIcon className="size-4" />;
    $[2] = isCopied;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="sr-only">Copy code to clipboard</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isCopied || $[6] !== t1 || $[7] !== t2) {
    t4 = <Button onClick={t1} aria-label="Copy code to clipboard" title="Copy code" data-copied={isCopied} className="hover:bg-border/35 text-muted-foreground/50 data-hover:text-muted-foreground data-focus:text-muted-foreground border-l p-4 data-focus:-outline-offset-2 data-focus:outline-blue-500 data-[copied=true]:text-lime-500">{t2}{t3}</Button>;
    $[5] = isCopied;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export function ThemeCodeGen(t0) {
  const $ = _c(5);
  const {
    slot
  } = t0;
  const [isLoading, setIsLoading] = useState(true);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isMounted = useIsMounted();
  let t1;
  let t2;
  if ($[0] !== isMounted) {
    t1 = () => {
      if (isMounted()) {
        setIsLoading(false);
      }
    };
    t2 = [isMounted];
    $[0] = isMounted;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (isLoading) {
    if (slot === "mobile") {
      return null;
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <CodeGenSkeleton />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (!isDesktop && slot === "desktop") {
    return null;
  }
  if (isDesktop && slot === "mobile") {
    return null;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ThemeCodeGenContent />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export const ThemeCodeGenContent = () => {
  const $ = _c(19);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const globalsCss = useGlobalsCssTemplate();
  const colorsTs = useColorsTsTemplate();
  let t0;
  if ($[0] !== colorsTs || $[1] !== globalsCss || $[2] !== selectedIndex) {
    t0 = () => {
      navigator.clipboard.writeText(selectedIndex === 0 ? globalsCss : colorsTs);
    };
    $[0] = colorsTs;
    $[1] = globalsCss;
    $[2] = selectedIndex;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleCopy = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tab className="data-hover:not-data-selected:bg-border/35 data-selected:from-border/50 data-selected:to-border border-r p-3 focus:not-data-focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 data-selected:bg-gradient-to-b data-selected:from-[calc(100%-4px)] data-selected:to-[calc(100%-4px)] sm:px-6"><TextMono>globals.css</TextMono></Tab>;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TabList>{t1}<Tab className="data-hover:not-data-selected:bg-border/35 data-selected:from-border/50 data-selected:to-border border-r p-3 focus:not-data-focus:outline-none data-focus:-outline-offset-2 data-focus:outline-blue-500 data-selected:bg-gradient-to-b data-selected:from-[calc(100%-4px)] data-selected:to-[calc(100%-4px)] sm:px-6"><TextMono>colors.ts</TextMono></Tab></TabList>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleCopy) {
    t3 = <div className="line-t lg:line-t/half mt-14 flex items-stretch justify-between lg:mt-8">{t2}<CopyButton onCopy={handleCopy} /></div>;
    $[6] = handleCopy;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== globalsCss) {
    t4 = <TabPanel><CodePreview code={globalsCss} language="css" /></TabPanel>;
    $[8] = globalsCss;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== colorsTs) {
    t5 = <TabPanel><CodePreview code={colorsTs} language="typescript" /></TabPanel>;
    $[10] = colorsTs;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <TabPanels className="line-y lg:line-y/half">{t4}{t5}</TabPanels>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== selectedIndex || $[16] !== t3 || $[17] !== t6) {
    t7 = <TabGroup selectedIndex={selectedIndex} onChange={setSelectedIndex}>{t3}{t6}</TabGroup>;
    $[15] = selectedIndex;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
const CodeGenSkeleton = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="from-border/50 to-border border-r bg-gradient-to-b from-[calc(100%-4px)] to-[calc(100%-4px)] p-3 sm:px-6"><TextMono>globals.css</TextMono></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="line-t lg:line-t/half flex items-stretch justify-between lg:mt-8"><div className="flex">{t0}<div className="border-r p-3 sm:px-6"><TextMono>colors.ts</TextMono></div></div><CopyButton onCopy={_temp} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="hidden lg:block">{t1}<div className="line-y lg:line-y/half"><CodePreview code="" language="css" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp() {
  return void 0;
}